import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const LanguageContext = createContext({
  language: "en",
  setLanguage: (nextLanguage) => {
    return nextLanguage;
  },
});

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window === "undefined") {
      return "en";
    }

    const savedLanguage = window.localStorage.getItem("eplus-language");
    return savedLanguage === "ko" || savedLanguage === "en" ? savedLanguage : "en";
  });

  useEffect(() => {
    window.localStorage.setItem("eplus-language", language);
  }, [language]);

  const value = useMemo(
    () => ({
      language,
      setLanguage: (nextLanguage) => {
        if (nextLanguage === "en" || nextLanguage === "ko") {
          setLanguage(nextLanguage);
        }
      },
    }),
    [language],
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
